import { HttpErrorResponse } from "@angular/common/http";
import { GetErrorMessageFromResponse } from "src/app/product-capture/utils/get-error-message-from-response";

export interface ErrorMessage {
  type: string;
  code: string;
  description: string;
  help: string;
}

export function getDocErrorMessage(error: HttpErrorResponse): string {
  let errorMessages = GetErrorMessageFromResponse(error);

  if (error?.error) {
    const { details } = error.error;

    if (!details?.length) {
      return errorMessages;
    }

    errorMessages = details
      .reduce((acc, error) => ([...acc, formatErrorMessage(error)]), [])
      .join('<br/>');
  }

  

  return errorMessages;
}

function formatErrorMessage(error: ErrorMessage): string {
  const { code, description, help } = error;
  return `${code}: ${description} - ${help}`;
}
